import React from 'react'
import BackIcon from 'assets/images/rectangle/right-green.svg'
import { useNavigate } from 'react-router-dom'
export default function Header({ title }: { title: string }) {
    const navigate = useNavigate()
    return (
        <div className=" w-full bg-transparent flex justify-between py-3 ">
            <img
                src={BackIcon}
                alt="back-icon"
                onClick={() => navigate(-1)}
                className=" cursor-pointer mr-2"
            />
            <p className=" text-green-1">{title}</p>
            <div></div>
        </div>
    )
}
